module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"rating":"{rating}/5","na":"NA"}}')
  delete Component.options._Ctor
}
